
<template>
  <v-container fluid class="pa-0 pb-8">
    <v-container class="container-custom">
        <Breadcrumbs :title="$t('modules.portalalumno.academic_charge.studyPlan.studyPlanView.title')" :description="$t('modules.portalalumno.academic_charge.studyPlan.studyPlanView.description')"></Breadcrumbs>
        <v-row justify="center">
            <v-col cols="12">
              <div class="mt-12 d-flex justify-center" v-if="loading">
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
              </div>
              <StudyPlanComponentMobile
                ref="study"
                v-if="isMobile"
                v-show="!loading"
                class="margin-bot"
              ></StudyPlanComponentMobile>
              <StudyPlanComponent
                ref="study"
                v-else
                v-show="!loading"
                @lodingState="loadingState"
              ></StudyPlanComponent>
            </v-col>
        </v-row>
    </v-container>
  </v-container>
</template>


<script>

import { $students } from '../Services'
import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs';
import StudyPlanComponent from '../Components/StudyPlanComponent/StudyPlanComponent'
import StudyPlanComponentMobile from '../Components/StudyPlanComponent/StudyPlanComponentMobile'
import { mapGetters } from 'vuex'

export default {
  name: 'StudyPlanView',
  components: {
    Breadcrumbs,
    StudyPlanComponent,
    StudyPlanComponentMobile
  },
  data() {
    return {
      loading: true
    }
  },
  computed: {
    ...mapGetters({
      studentCareer: 'commons/getStudentCareer',
      studentRegister: 'commons/getStudentActualRegister',
    }),
    isMobile() {
      let check = false;
      //eslint-disable-next-line
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      return check;
    },
  },
  methods: {
    loadingState() {
      this.loading = false
    },
    async fetchData() {
      this.loading = true
      const response = await $students.findById(this.studentRegister, 'study-plan');
      const subjects = this.subjectWithPrerequisites(response.data.subjects)
      this.$refs.study.subjectsParcer(subjects)
      this.loading = false
    },
    subjectWithPrerequisites(subjects) {
      const array = []
      subjects.forEach(subject => {
        if (subject.preRequisites) {
          subject.preRequisites.forEach(pre => {
            if (!array[pre]) array[pre] = []
            array[pre].push(subject.subject.descripcion)
          });
        }
      });
      return subjects.map(subject => {
        subject.preRequisitesFrom = array[subject.subject.descripcion]
        return subject
      })
    }
  },
  mounted() {
    this.fetchData();
  }
}
</script>

<style lang="sass">
  .study-plan
    overflow-x: auto
    padding-bottom: 5px
    .grid-1
      grid-template-columns: repeat(1, 1fr)
    .grid-column-1
      grid-column: 1
    .grid-row-1
      grid-row: 1

    .grid-2
      grid-template-columns: repeat(2, 1fr)
    .grid-column-2
      grid-column: 2
    .grid-row-2
      grid-row: 2

    .grid-3
      grid-template-columns: repeat(3, 1fr)
    .grid-column-3
      grid-column: 3
    .grid-row-3
      grid-row: 3

    .grid-4
      grid-template-columns: repeat(4, 1fr)
    .grid-column-4
      grid-column: 4
    .grid-row-4
      grid-row: 4

    .grid-5
      grid-template-columns: repeat(5, 1fr)
    .grid-column-5
      grid-column: 5
    .grid-row-5
      grid-row: 5

    .grid-6
      grid-template-columns: repeat(6, 1fr)
    .grid-column-6
      grid-column: 6
    .grid-row-6
      grid-row: 6

    .grid-7
      grid-template-columns: repeat(7, 1fr)
    .grid-column-7
      grid-column: 7
    .grid-row-7
      grid-row: 7

    .grid-8
      grid-template-columns: repeat(8, 1fr)
    .grid-column-8
      grid-column: 8
    .grid-row-8
      grid-row: 8

    .grid-9
      grid-template-columns: repeat(9, 1fr)
    .grid-column-9
      grid-column: 9
    .grid-row-9
      grid-row: 9

    .grid-10
      grid-template-columns: repeat(10, 1fr)
    .grid-column-10
      grid-column: 10
    .grid-row-10
      grid-row: 10

    .grid-11
      grid-template-columns: repeat(11, 1fr)
    .grid-column-11
      grid-column: 11
    .grid-row-11
      grid-row: 11

    .grid-12
      grid-template-columns: repeat(12, 1fr)
    .grid-column-12
      grid-column: 12
    .grid-row-12
      grid-row: 12

</style>